module.exports = __webpack_public_path__ + "img/header-bg.32eb33b5.png";